/**
 * Neutral German labels for tenancy display_status, used by the external
 * landlord/tenant portals. Intentionally separate from the admin-specific
 * getStatusMeta (which carries admin badge styling and broader status keys) —
 * a small neutral utility keeps the portals decoupled from admin internals.
 *
 * Keys mirror tenancy_lifecycle.tenancy_derived_display_status:
 * active | reserved | notice_given | ended | cancelled.
 */
const TENANCY_STATUS_LABELS_DE = {
  active: "Aktiv",
  reserved: "Reserviert",
  notice_given: "Gekündigt",
  ended: "Beendet",
  cancelled: "Storniert",
};

export function tenancyStatusLabelDe(status) {
  if (!status) return "—";
  return TENANCY_STATUS_LABELS_DE[status] || status; // unknown → raw value, defensive
}
